import { api } from '../api';

export type AlertType = 'UNUSED' | 'SCORE_DROP';
export type AlertSeverity = 'INFO' | 'WARNING' | 'CRITICAL';

export interface ActiveAlert {
  id: string;
  type: AlertType;
  severity: AlertSeverity;
  message: string;
  residentId: string;
  roomNumber: string | null;
  floor: number | null;
  name: string | null;
  patientCode: string | null;
  createdAt: string;
}

export async function getActiveAlerts(params?: { type?: AlertType }): Promise<ActiveAlert[]> {
  const res = await api.get<ActiveAlert[]>('/alerts', { params });
  return res.data;
}
